import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { StoreContext } from '../../../components/App'

import { Link } from 'react-router'
import { ToRight } from '../EnrollCompany.styles'
import {
  Circle,
  Container,
  Content,
  ContentSection,
  ProceedButton,
} from './enroll.styles'
import { PageHeading } from '../../../components/PageHeading/PageHeading'
import CircleLogo from '../../../assets/company_intro.svg'

export const IntroCompanyData = observer(() => {
  const store = useContext(StoreContext)
  const { theme, themeName } = store.AppState
  const {
    enrollCompanyPage: { introCompanyData: trans },
  } = store.TranslationsState.translations

  return (
    <Container>
      <PageHeading margin="0 0 0 40px" marginMobile="0 0 0 80px" />
      <Content>
        <ContentSection>
          <Circle margin="0">
            <img src={CircleLogo} />
          </Circle>
          <p>{trans.description}</p>
        </ContentSection>
        <ToRight>
          <Link to={`/enroll-company/company-data?themeId=${themeName}`}>
            <ProceedButton {...theme.proceedButton}>
              {trans.continue}
            </ProceedButton>
          </Link>
        </ToRight>
      </Content>
    </Container>
  )
})
